import { LayerType } from '@/views/map/layers/types';

/**
 * Checks if a layer type is available in the datasets
 * @param datasets - Array of available datasets from auth context
 * @param layerType - Layer type to check (can be LayerType enum or string)
 * @returns true if the layer is available, false otherwise
 */
export const hasLayer = (
  datasets: Array<{ layerType: string }>,
  layerType: LayerType | string
): boolean => {
  const l = typeof layerType === 'string' ? layerType : LayerType[layerType];
  return datasets.findIndex((d) => d.layerType === l) !== -1;
};
